/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupJob } from '../models/BackupJob';
import { Pagination } from '../models/Pagination';

export class ListBackupJobsInternal200Response {
  'data'?: Array<BackupJob>;
  'pagination'?: Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<BackupJob>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListBackupJobsInternal200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

